import React from 'react'
import { Outlet } from 'react-router-dom';
import SideBar from './../../Components/SideBar/SideBar.jsx';
import style from './Layout.module.css'
import NavBar from './../../Components/NavBar/NavBar.jsx';

export default function Layout() {
    
    return (
        <div className={`${style.container} mx-auto px-4 pt-5 pb-10 md:mb-0 `}>
            <div className='grid grid-cols-12 gap-4'>
                <section className={`col-span-12 md:col-span-5 lg:col-span-4 xl:col-span-3 px-2 py-7 rounded-xl h-fit ${style.shadowBlockInner}`}>
                    <SideBar />
                </section>
                <section className={`col-span-12 md:col-span-7 lg:col-span-8 xl:col-span-9 pr-2 pl-6 py-7 rounded-xl h-fit min-h-48 relative ${style.shadowBlockInner}`}>
                    <NavBar />
                    <Outlet></Outlet>
                </section>
            </div>
        </div>
    )
}
